<template>
  <article class="user_view">
    <left-menu/>
    <section class="user_view__header">
      <div @click="$router.push({ name: 'Coordinators' })" class="back_button">
        <img src="./../../assets/img/icons/back-button.svg">
        <span>atrás</span>
      </div>
      <div class="user_view__header--info"> 
        <div>
          <h2>{{coordinator.user.name + ' ' + coordinator.user.last_name}}</h2>
          <h4>CC. {{coordinator.user.id_card}}</h4>
          <div class="user_view__header--sec1">
            <!--div class="date_filter">
                <input type="date" class="date_filter__selector">
                <button :class="{'active':true}"  class="secondary_button" >FILTRAR</button>
              
            </div-->
          </div>
        </div>
      </div>
      <info-table  :columns="columns" :items.sync="coordinator.devices" :actions="false"/>
    </section>
    
  </article>
</template>

<script>
import Table from './../shared/Table';
export default {
  data(){
    return{
      columns:[
        {
          name: 'Puesto de trabajo',
          sortable: false,
        },
        {
          name: 'Dispositivo',
          sortable: false,
        },
        
      ],
      mockedCoord: 
        {
          user:{
            card_company: 2893049,
            name: 'Mario José',
            last_name: 'Díaz Martínez',
            id_card: '1098765375',
          },
          devices:[{
            number:319838238,
            company: 'Fusepong S.A.S',
            location: 'Piso 1 - Entrada 5 - Edificio de Gobernación de Neiva',
          },
          {
            number:320654545,
            company: 'Fusepong S.A.S',
            location: 'Piso 2 - Entrada 3 - Edificio de Gobernación de Neiva',
          }]
        },
      coordinator:{
        user:{
          card_company: '',
          name: '',
          last_name: '',
          id_card: '',
        },
        devices:[
        ]
      },
    }
  },
  created(){
    const customActions={
        get: {headers:{"Authorization": 'Bearer '+localStorage.getItem('crypto')},method: 'GET'}                   
    };
    this.$resource('coordinators/dashboard/'+ this.$route.params.id,{},customActions).get()
    .then(function(data){
      this.coordinator=data.body;
      //console.log(data.body[0].user);
    });
  },
  components:{
    'info-table':Table, 
  },
}
</script>



// WEBPACK FOOTER //
// src/components/pages/Coordinator.vue